import { z } from "zod";
import { STATE,
  LICENSE_CATEGORY,
  AUDIT_SCOPE,
  EFFECTIVE_DATE,
  DESCRIPTION,
  INCLUDE_STATE_LAW, 
  CONTENT,
  TEMPLATE_NAME,
  VERSION_NO,
  STATUS} from "./consts";

export const addSchema = z.object({
  [STATE]: z.string().min(1, "This field is required"),
  [LICENSE_CATEGORY]: z.string().min(1, "This field is required"),
  [AUDIT_SCOPE]: z.string().min(1, "This field is required"),
  [EFFECTIVE_DATE]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
  [INCLUDE_STATE_LAW]: z.boolean().optional(),
  [CONTENT]: z.string().optional(),
  [TEMPLATE_NAME]: z.string().optional(),
  [VERSION_NO]: z.string().optional(),
  [STATUS]: z.string().optional(),
});

export type formValues = z.infer<typeof addSchema>;
